import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import './index.css';
// Design system EGORA (redesenho, Fase 0). Carrega DEPOIS do CSS antigo: nos nomes
// que os dois usam (--accent, --surface...), o EGORA precisa vencer na cascata.
import './styles/egora-tokens.css';
import './styles/egora.css';

// IMPORTANTE: quillPatch deve ser importado ANTES de App para garantir
// que o monkey-patch no IconPicker esteja ativo antes de qualquer
// componente ReactQuill montar (fix para React 18 StrictMode double-mount).
import 'src/quillPatch';

import App from 'src/App';
import { AuthProvider } from 'src/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'src/ThemeContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'src/queryClient';
import { capturarSegredoDoLink } from 'src/utils/segredoDoLink';
import { capturarTokenDeRecuperacaoMfa } from 'src/utils/tokenDeRecuperacaoMfa';

// Item 4C: o segredo do link de senha sai da barra ANTES de qualquer coisa
// observar a navegação, e antes do StrictMode (que repete inicializadores).
capturarSegredoDoLink();
capturarTokenDeRecuperacaoMfa();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// ── PWA — Registro do Service Worker ──────────────────────
// Ativado apenas em produção (HTTPS). Em dev, usa hot-reload normal.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        console.info('[PWA] Service Worker registrado.', reg.scope);
      })
      .catch((err) => {
        console.warn('[PWA] Falha ao registrar Service Worker:', err);
      });
  });
}
